import type { GameMode } from '@interactive-room';

/** Modalidades que funcionan como actividad en vivo independiente (no bloques de guía). */
export const LIVE_HOST_MODES: GameMode[] = [
  'poll',
  'arena',
  'order',
  'vincula',
  'sandbox',
  'coop',
  'point',
  'wall',
];

export function isLiveHostMode(mode: GameMode): boolean {
  return LIVE_HOST_MODES.includes(mode);
}
